import React from 'react';
import { X } from 'react-feather';
import Text from '../atoms/Text';
import Button from '../atoms/Button';

export default function NlResponse({
    label = "HELP",
    title,
    responseLabel = "Response:",
    response,
    tryLabel = "Try:",
    commandExample,
    onClose,
    onTryCommand
}) {
    if (!title && !response) return null;

    const commands = Array.isArray(commandExample) ? commandExample : (commandExample ? [commandExample] : []);

    return (
        <div className="relative w-full bg-gray-900 rounded-lg p-3 mt-4 overflow-hidden shadow-card z-[99]">
            <div className="absolute inset-0 bg-success-500 opacity-[0.08] pointer-events-none" />

            <div className="relative z-10">
                <div className="flex items-center justify-between mb-1">
                    <Text
                        variant="bodySmall"
                        fontWeight="font-semibold"
                        className="text-gray-200 uppercase tracking-normal"
                    >
                        {label}
                    </Text>
                    <button
                        onClick={onClose}
                        className="text-gray-100 hover:text-basic-100 transition-colors p-1 -mr-1"
                    >
                        <X size={14} />
                    </button>
                </div>

                {title && (
                    <Text
                        variant="bodySmall"
                        fontWeight="font-normal"
                        className="text-gray-100 mb-4 leading-4"
                    >
                        {title}
                    </Text>
                )}

                <div className="mb-4">
                    <Text
                        variant="bodySmall"
                        fontWeight="font-medium"
                        className="text-warning-300 mb-2 leading-4"
                    >
                        {responseLabel}
                    </Text>
                    <Text
                        variant="bodySmall"
                        fontWeight="font-normal"
                        className="text-gray-100 whitespace-pre-wrap leading-4"
                    >
                        {response}
                    </Text>
                </div>

                {commands.length > 0 && (
                    <div className="mt-4">
                        <Text
                            variant="bodySmall"
                            fontWeight="font-medium"
                            className="text-gray-200 mb-2 leading-4"
                        >
                            {tryLabel}
                        </Text>
                        <div className="flex flex-wrap gap-2">
                            {commands.map((cmd, idx) => (
                                <Button
                                    key={idx}
                                    label={cmd}
                                    type="ghost"
                                    buttonTheme="success"
                                    size="tiny"
                                    textSize="text-sm"
                                    onClick={() => onTryCommand && onTryCommand(cmd)}
                                    className="!bg-transparent !border-success-500 !text-success-500 font-semibold"
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
